import { render, staticRenderFns } from "./RekeningBank.vue?vue&type=template&id=2f5f0010&"
import script from "./RekeningBank.vue?vue&type=script&lang=js&"
export * from "./RekeningBank.vue?vue&type=script&lang=js&"
import style0 from "./RekeningBank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports